function base64UrlDecode(str) {
  const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  const pad = (4 - (base64.length % 4)) % 4;
  const padded = base64 + '='.repeat(pad);
  return atob(padded);
}

export const isTokenExpired = (token) => {
  if (!token) return true;

  try {
    const payloadBase64 = token.split('.')[1];
    const payloadJson = base64UrlDecode(payloadBase64);
    const payload = JSON.parse(payloadJson);

    if (typeof payload.exp !== 'number') return true;

    const currentTime = Date.now() / 1000;
    return payload.exp < currentTime;
  } catch (e) {
    console.warn("Invalid token format", e);
    return true; // Treat as expired/invalid
  }
};